var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%"}},[_c('TryRead',{attrs:{"fatherId":_vm.fatherid,"tryReadId":_vm.tryReadId,"firstChildId":_vm.firstchildId,"InformationId":_vm.InformationId,"sellWay":_vm.sellway,"isIndex":_vm.isIndex}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e5aab90","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/BookDetails/BookTryRead.vue
// module id = null
// module chunks = 